// src/core/base-services.js
import EventManager from "../../core/event-bus";

/**
 * 直播服务抽象基类
 */
export class BaseWhiteBoardService {
  constructor() {
    if (new.target === BaseWhiteBoardService) {
      throw new Error(
        "Cannot instantiate abstract class BaseWhiteBoardService"
      );
    }
    this.eventManager = new EventManager();
    this.client = null;
    this.selectElementInfo = {};
  }

  // 事件相关方法
  on(eventName, callback) {
    return this.eventManager.on(eventName, callback);
  }

  once(eventName, callback) {
    return this.eventManager.once(eventName, callback);
  }

  off(eventName, callback) {
    return this.eventManager.off(eventName, callback);
  }

  // 受保护的方法，供子类调用以触发事件
  _emit(eventName, data) {
    this.eventManager.emit(eventName, data);
  }

  /**
   * @abstract
   * @param {any} data - 同步数据
   * @returns {void}
   * @throws {Error} 如果子类没有实现此方法
   */
  addSyncData(data) {
    throw new Error(
      `Abstract method 'addSyncData' must be implemented in ${this.constructor.name}`
    );
  }

  /**
   * @abstract
   * @returns {void}
   * @throws {Error} 如果子类没有实现此方法
   */
  prevBoard() {
    throw new Error(
      `Abstract method 'prevBoard' must be implemented in ${this.constructor.name}`
    );
  }

  /**
   * @abstract
   * @returns {void}
   * @throws {Error} 如果子类没有实现此方法
   */
  nextBoard() {
    throw new Error(
      `Abstract method 'nextBoard' must be implemented in ${this.constructor.name}`
    );
  }

  // 修改画笔样式
  setPenStyle(style) {
    throw new Error(
      `Abstract method 'setPenStyle' must be implemented in ${this.constructor.name}`
    );
  }
  // 修改形状样式
  setShapeStyle(style) {
    throw new Error(
      `Abstract method 'setShapeStyle' must be implemented in ${this.constructor.name}`
    );
  }
  // 修改文本样式
  setTextStyle(style) {
    throw new Error(
      `Abstract method 'setTextStyle' must be implemented in ${this.constructor.name}`
    );
  }
  // 设置鼠标
  setMouseTool() {
    throw new Error(
      `Abstract method 'setMouseTool' must be implemented in ${this.constructor.name}`
    );
  }
  // 设置橡皮檫
  setEraserTool() {
    throw new Error(
      `Abstract method 'setEraserTool' must be implemented in ${this.constructor.name}`
    );
  }
  // 设置激光笔
  setLaserTool() {
    throw new Error(
      `Abstract method 'setLaserTool' must be implemented in ${this.constructor.name}`
    );
  }
  // 清空当前白板
  clear() {
    throw new Error(
      `Abstract method 'clear' must be implemented in ${this.constructor.name}`
    );
  }
  // 判断当前白板是否有内容
  isEmpty() {
    throw new Error(
      `Abstract method 'isEmpty' must be implemented in ${this.constructor.name}`
    );
  }
  // 销毁
  undo() {
    throw new Error(
      `Abstract method 'undo' must be implemented in ${this.constructor.name}`
    );
  }
  //恢复上一次撤销
  redo() {
    throw new Error(
      `Abstract method 'redo' must be implemented in ${this.constructor.name}`
    );
  }

  /**
   * 设置白板的缩放比例
   * @param {number} scale - 要设置的缩放比例值
   */
  setBoardScale(scale) {
    throw new Error(
      `Abstract method 'setBoardScale' must be implemented in ${this.constructor.name}`
    );
  }
  /**
   * 获取白板的当前缩放比例
   * @returns {number} 白板的当前缩放比例值
   */
  getBoardScale() {
    throw new Error(
      `Abstract method 'getBoardScale' must be implemented in ${this.constructor.name}`
    );
  }

  getFileInfo() {
    throw new Error(
      `Abstract method 'getFileInfo' must be implemented in ${this.constructor.name}`
    );
  }

  // 增加一页白板
  addBoard() {
    throw new Error(
      `Abstract method 'addBoard' must be implemented in ${this.constructor.name}`
    );
  }

  // 删除元素
  removeElement(elements) {
    throw new Error(
      `Abstract method 'removeElement' must be implemented in ${this.constructor.name}`
    );
  }

  // 获取白板全局背景
  getBoardBackground() {
    throw new Error(
      `Abstract method 'getBoardBackground' must be implemented in ${this.constructor.name}`
    );
  }

  // 设置白板全局背景
  setBoardBackground(background) {
    throw new Error(
      `Abstract method 'setBoardBackground' must be implemented in ${this.constructor.name}`
    );
  }

  // 设置白板允许涂鸦
  setDrawEnable(enable) {
    throw new Error(
      `Abstract method 'setDrawEnable' must be implemented in ${this.constructor.name}`
    );
  }

  //重新计算白板大小，并渲染
  resizeBoard() {
    throw new Error(
      `Abstract method 'resizeBoard' must be implemented in ${this.constructor.name}`
    );
  }
}
